import BackTop from 'antd/lib/back-top';
import './index.less';

export default BackTop;



// WEBPACK FOOTER //
// ./src/elements/backtop/index.js